import { OrderItemMiscModel } from './order-item-misc-model';
import { OrderItemMiscType } from './order-item-misc-type';

export class MiscItemCreateModel {
	constructor(
		public Reference: string,
		public Amount: number,
		public Ecommerce: string | null | undefined,
		public EcommerceVariantCode: string | undefined,
		public EcommerceNoUnique: string | null | undefined,
		public Description: string | undefined,
		public CategoryDescription: string | undefined,
		public CustomerNo: string | undefined,
		public KidTeen: boolean,
		public ToolsIncluded: boolean,
		public ProductLineCode: string | null,
		public Type: OrderItemMiscType,
		public OrderId: number | undefined | null,
		public DiscountCode: string,
		public DiscountPercent: number
	) { }

	public static Create(orderItemMiscModel: OrderItemMiscModel): MiscItemCreateModel {
		const createModel = new MiscItemCreateModel(
			orderItemMiscModel.Reference,
			orderItemMiscModel.Amount,
			orderItemMiscModel.Ecommerce,
			orderItemMiscModel.EcommerceVariantCode,
			orderItemMiscModel.EcommerceNoUnique,
			orderItemMiscModel.Description, orderItemMiscModel.MiscModel?.ItemCategoryDescription,
			orderItemMiscModel.CustomerNo,
			orderItemMiscModel.KidTeen,
			orderItemMiscModel.ToolsIncluded,
			orderItemMiscModel.ProductLineCode,
			orderItemMiscModel.Type,
			orderItemMiscModel.OrderId,
			orderItemMiscModel.DiscountCode,
			orderItemMiscModel.DiscountPercent
		);
		return createModel;
	}
}
